<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات برداشت ها</h5>

      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">کاربری</label>
          <input [(ngModel)]="Filter_Schedule_User" name="Filter_Schedule_User" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام مشتری</label>
          <input [(ngModel)]="Filter_Customer_Name" name="Filter_Customer_Name" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="Filter_Letter_Code" name="Filter_Letter_Code" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره حکم</label>
          <input [(ngModel)]="Filter_Schedule_Code" name="Filter_Schedule_Code" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">وضیعت</label>
          <select [(ngModel)]="Filter_Status" name="Filter_Status" class="custom-select">
            <option value="-2">همه موارد</option>
            <option value="0">در حال بررسی</option>
            <option value="1">تایید شد</option>
            <option value="-1">رد شد</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Funds(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

          <label style="font-weight: bolder;">جمع کل : {{DataList_Funds_Charge_Price|number}}</label>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>نام مشتری</th>
              <th>شماره نامه</th>
              <th>شماره حکم</th>
              <th>مبلغ هزینه (ريال)</th>
              <th>تاریخ هزینه</th>
              <th>عنوان هزینه</th>
              <th>شرح</th>
              <th>فایل ضمیمه</th>
              <th>وضیعت</th>
              <th>ناریخ</th>
              <th>کاربری</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds_Charge
            |filter:Filter_Schedule_Code:'code2'
            |filter:Filter_Letter_Code:'code3'
            |filter:Filter_Customer_Name:'customer'
            | paginate
                    : {
                        id: 'DataList_UserTable_Charge',
                        itemsPerPage: 10,
                        currentPage: page_Charge,
                        totalItems: (DataList_Funds_Charge
                        |filter:Filter_Schedule_Code:'code2'
                        |filter:Filter_Letter_Code:'code3'
                        |filter:Filter_Customer_Name:'customer').length
                      }
            ">
            <td>{{DataList_Funds_Charge.indexOf(item)+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.customer}}</td>
            <td>{{item.code3}}</td>
            <td>{{item.code2}}</td>
            <td>{{item.price | number}}</td>
            <td>{{item.price_date}}</td>
            <td>{{item.title}}</td>
            <td>{{item.dsc}}</td>
            <td>
             <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Funds/{{item.src}}"   *ngIf="item.src" ><i class="fa fa-download"></i> دانلود </a>
            </td>
            <td>
             <p *ngIf="item.status==0" style="color: #39539b;">در حال بررسی</p>
             <p *ngIf="item.status==1" style="color: 489b39;">تایید شد</p>
             <p *ngIf="item.status==-1" style="color: crimson;">رد شد</p>
            </td>
            <td>{{item.subdate}}</td>
            <td>{{item.username}}</td>
            </tr>
          </tbody>

        </table>
      </div>

      <pagination-controls id="DataList_UserTable_Charge" nextLabel="بعدی" previousLabel="قبلی"
        (pageChange)="page_Charge = $event"></pagination-controls>
    </div>
  </div>
</div>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>شناسه</th>
      <th>نام مشتری</th>
      <th>شماره نامه</th>
      <th>شماره حکم</th>
      <th>مبلغ هزینه (ريال)</th>
      <th>تاریخ هزینه</th>
      <th>عنوان هزینه</th>
      <th>شرح</th>
      <th>وضیعت</th>
      <th>ناریخ</th>
      <th>کاربری</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Funds_Charge
    |filter:Filter_Schedule_Code:'code2'
    |filter:Filter_Letter_Code:'code3'
    |filter:Filter_Customer_Name:'customer'">

        <td>{{item.code}}</td>
        <td>{{item.customer}}</td>
        <td>{{item.code3}}</td>
        <td>{{item.code2}}</td>
        <td>{{item.price | number}}</td>
        <td>{{item.price_date}}</td>
        <td>{{item.title}}</td>
        <td>{{item.dsc}}</td>
        <td>
        <p *ngIf="item.status==0" style="color: #39539b;">در حال بررسی</p>
        <p *ngIf="item.status==1" style="color: 489b39;">تایید شد</p>
        <p *ngIf="item.status==-1" style="color: crimson;">رد شد</p>
        </td>
        <td>{{item.subdate}}</td>
        <td>{{item.username}}</td>
    </tr>
  </tbody>
</table>
